import { apiClient } from './client';
import type { Envelope } from './types';

export interface Summary {
  totalRecords: number;
  recordsInRange: number;
  avgWeightKg: string | null;
  latestWeightKg: string | null;
  latestBmi: string | null;
  latestDate: string | null;
  startWeightKg: string | null;
  weightChangeKg: string | null;
  weightChangePct: string | null;
}

export interface TrendPoint {
  date: string;
  value: number;
}

export interface CategoryBucket {
  categoryId: number | null;
  name: string;
  color: string | null;
  count: number;
}

export interface BmiDistribution {
  underweight: number;
  normal: number;
  overweight: number;
  obese: number;
}

export type TrendMetric = 'weight' | 'bmi';
export type RangeDays = number;

export async function getSummary(range: RangeDays = 30): Promise<Summary> {
  const res = await apiClient.get<Envelope<Summary>>('/analytics/summary', {
    params: { range },
  });
  return res.data.data;
}

export async function getTrends(
  range: RangeDays = 30,
  metric: TrendMetric = 'weight'
): Promise<TrendPoint[]> {
  const res = await apiClient.get<Envelope<TrendPoint[]>>('/analytics/trends', {
    params: { range, metric },
  });
  return res.data.data;
}

export async function getCategoryDistribution(range: RangeDays = 30): Promise<CategoryBucket[]> {
  const res = await apiClient.get<Envelope<CategoryBucket[]>>('/analytics/distribution/categories', {
    params: { range },
  });
  return res.data.data;
}

export async function getBmiDistribution(range: RangeDays = 30): Promise<BmiDistribution> {
  const res = await apiClient.get<Envelope<BmiDistribution>>('/analytics/distribution/bmi', {
    params: { range },
  });
  return res.data.data;
}
